import { makeAutoObservable } from 'mobx';
import { AvatarUserInterface } from '../../interfaces/WorkspaceInterface';
import { RawUser, userActivity } from '../interfaces/user';
import { rootStore } from '../rootStore';
import { groupMyTasksByFilter } from '../../services/mobxTaskFilterService';
import { DEFAULT_DATE_FORMAT } from '../../global/constants';
import { AiAgent } from '../interfaces/workspace';

export class UserModel {
  // Common
  id: string;
  email: string;
  name: string;
  avatar: AvatarUserInterface;
  isOwner?: boolean;
  isAdmin: boolean;
  phone: string | undefined;
  profile_photo: string | undefined;
  role?: number;

  dateFormat: string;
  deviceId: string | null;
  timeZone: string | null;
  userActivity: userActivity[] = [];

  constructor(rawUser: RawUser) {
    makeAutoObservable(this);

    this.id = rawUser.id;
    this.email = rawUser.email;
    this.name = rawUser.name;
    this.avatar = rawUser.avatar;
    this.isOwner = rawUser.isOwner;
    this.isAdmin = rawUser.isAdmin;
    this.phone = rawUser.phone;
    this.profile_photo = rawUser.profile_photo;
    this.role = rawUser.role;
    this.dateFormat = rawUser.dateFormat ?? DEFAULT_DATE_FORMAT;
    this.deviceId = rawUser.deviceId ?? null;
    this.timeZone = rawUser.timeZone ?? null;
  }

  get tasks() {
    return rootStore.taskStore.tasks.filter((task) => task.usersIds.includes(this.id) && !task.status);
  }

  get filteredTasks() {
    return groupMyTasksByFilter(this.tasks, rootStore.taskStore.myTasksFilter);
  }

  setUserActivity(activityData: userActivity[]) {
    this.userActivity = activityData;
  }
}

export const createObservableUser = (rawUser: RawUser) => {
  return new UserModel(rawUser);
};

export const createObservableUserFromAiAgent = (aiAgent: AiAgent) => {
  const rawUser: RawUser = {
    id: aiAgent.id,
    email: '',
    name: aiAgent.name,
    avatar: {
      avatar: aiAgent.profile_photo,
      avatar_120: aiAgent.profile_photo
    },
    isAdmin: false,
    phone: undefined,
    profile_photo: aiAgent.profile_photo
  };

  return new UserModel(rawUser);
};
